module.exports = __webpack_public_path__ + "img/filmvdo.930ff492.png";